const initialState=[
    {
      'id': '1',
      'urn': 'docs',
      'unitname': 'Руководящие и служебные документы',
      'unitdescr': 'Служебные записки, заявки',
      'link': 'ss',
      'unitx': 1,
    },

    {
      'id': 2,
      'urn':'info',
      'unitname': 'Информация',
      'unitdescr': 'Положение об ОЦНИТ, общая информация',

    },

    {
      'id': 3,
      'urn':'jobs',
      'unitname': 'Новости',
      'unitdescr': 'Текущие изменения предоставления услуг',
      'unitline': '1',
      'unitx': 3,
    },

    {
      'id': 4,
      'unitname': 'Компьютерная сеть университета',
      'unitdescr': 'Описание, нормативные документы',
      'unitline': '2',
    },

    {
      'id': 5,
      'unitname': 'Подключение к сети университета',
      'unitdescr': 'Порядок подключения, заявки',
      'unitline': '2',
    },

    {
      'id': 6,
      'unitname': 'Коммерческие услуги',
      'unitdescr': 'Телемаческие и иные услуги на коммерческой основе',
      'unitline': '2',
    },

    {
      'id': 7,
      'unitname': 'Инструкция по настройкам сети',
      'unitdescr':  'Настройка IP-адресов, PROXY-сервера',
      'unitline': '2',
    },
    {
      'id': 8,
      'unitname': 'Удаленный доступ',
      'unitdescr': 'Инструкция по настройке VPN',
      'unitline': '2',
    },
    {
      'id': 9,
      'unitname': 'Решение проблем',
      'unitdescr': 'Устранение неисправностей, нештатные ситуации',
      'unitline': '2',
      'link': 'Problem',
    },
    {
      'id': 10,
      'unitname':'Служба технической поддержки',
      'unitdescr': 'Обращения, контактная информация',
      'unitline': '2',
    },
    {
    'id': 11,
    'unitname':'Заявки в службу сервиса',
    'unitdescr': 'Статус исполнения заявок, статистика',
    'unitline': '2',
    },
    {
    'id': 12,
    'unitname':'IP адреса',
    'unitdescr': 'Адресный план',
    'unitline': '2',
  },
]




export default function titleunits(state = initialState, action) {

  return state;


}
